class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    const quantitySelector = this.querySelector(".js-quantity-input");
    const minus = this.querySelector(".js-minus");
    const plus = this.querySelector(".js-plus");
    if (quantitySelector && minus && plus) {
      minus.addEventListener("click", () => {
        if (quantitySelector.value > 1) {
          quantitySelector.value = parseInt(quantitySelector.value) - 1;
        }
      });
      plus.addEventListener("click", () => {
        if (Number(quantitySelector.value) < Number(quantitySelector.dataset.max)) {
          quantitySelector.value = parseInt(quantitySelector.value) + 1;
        }
      });
    }
  }
}
if (customElements.get("quantity-selector") === void 0) {
  customElements.define("quantity-selector", QuantitySelector);
}
